(function(){
  'use strict';
  var CFG=window.LMP_MANAGER_CONFIG||{};
  // No Manager endpoint is configured: avoid background work in the regular storefront.
  var mode=window.LMP_APP_CONFIG||{};
  if(CFG.enabled===false||(!CFG.endpoint&&!mode.standalone&&!mode.previewMode))return;
  var QUEUE_KEY='lmp_manager_queue_v1';
  var MAX_QUEUE=250;
  var flushing=false;

  function readQueue(){
    try{var q=JSON.parse(localStorage.getItem(QUEUE_KEY)||'[]');return Array.isArray(q)?q:[]}catch(e){return[]}
  }
  function writeQueue(q){try{localStorage.setItem(QUEUE_KEY,JSON.stringify(q.slice(-MAX_QUEUE)))}catch(e){}}
  function uid(){
    try{if(window.crypto&&crypto.randomUUID)return crypto.randomUUID()}catch(e){}
    return 'evt-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
  }
  function cleanObject(value,depth){
    depth=depth||0;
    if(depth>3)return undefined;
    if(value==null||typeof value==='string'||typeof value==='number'||typeof value==='boolean')return value;
    if(Array.isArray(value))return value.slice(0,20).map(function(v){return cleanObject(v,depth+1)});
    if(typeof value==='object'){
      var out={},count=0;
      Object.keys(value).forEach(function(k){if(count>=40)return;var v=cleanObject(value[k],depth+1);if(v!==undefined){out[String(k).slice(0,60)]=v;count++;}});
      return out;
    }
  }
  function envelope(detail){
    var ctx=window.LMP_ANALYTICS_CONTEXT||{};
    var params=(detail&&detail.params)||{};
    return {
      event_id:uid(),
      event_name:String((detail&&detail.name)||'lmp_event').slice(0,60),
      occurred_at:new Date().toISOString(),
      theme_id:String(CFG.themeId||ctx.themeId||'156161048673'),
      theme_name:String(CFG.themeName||ctx.themeName||'La Maison Para – PWA Native 2026 – Test').slice(0,120),
      environment:String(CFG.environment||ctx.environment||'test').slice(0,30),
      app_version:String(CFG.appVersion||ctx.appVersion||'2026-native-test-v1').slice(0,60),
      install_id:String(params.lmp_install_id||'').slice(0,100),
      app_mode:String(params.lmp_app_mode||'web').slice(0,30),
      page_path:String(params.page_path||location.pathname||'/').slice(0,220),
      params:cleanObject(params,0)
    };
  }
  function queueEvent(ev){var q=readQueue();q.push(ev);writeQueue(q);status();flush();}
  function endpoint(){return String(CFG.endpoint||'').trim()}
  function status(){
    var state={connected:!!endpoint(),queued:readQueue().length,themeId:String(CFG.themeId||''),environment:String(CFG.environment||'test')};
    window.LMPManagerBridgeStatus=state;
    try{document.dispatchEvent(new CustomEvent('lmp:manager-status',{detail:state}))}catch(e){}
  }
  function sendOne(ev){
    var url=endpoint();
    if(!url)return Promise.resolve(false);
    var body=JSON.stringify(ev);
    if(navigator.sendBeacon){
      try{var blob=new Blob([body],{type:'text/plain;charset=UTF-8'});if(navigator.sendBeacon(url,blob))return Promise.resolve(true)}catch(e){}
    }
    return fetch(url,{method:'POST',mode:'no-cors',credentials:'omit',keepalive:true,headers:{'Content-Type':'text/plain;charset=UTF-8'},body:body}).then(function(){return true}).catch(function(){return false});
  }
  function flush(){
    if(flushing||!endpoint())return;
    var q=readQueue();if(!q.length){status();return}
    flushing=true;
    var remaining=q.slice();
    (function next(){
      if(!remaining.length){writeQueue([]);flushing=false;status();return}
      var ev=remaining[0];
      sendOne(ev).then(function(ok){
        if(!ok){writeQueue(remaining);flushing=false;status();return}
        remaining.shift();writeQueue(remaining);next();
      });
    })();
  }
  document.addEventListener('lmp:analytics',function(e){if(e&&e.detail)queueEvent(envelope(e.detail))});
  window.addEventListener('online',flush);
  window.addEventListener('pageshow',function(){status();flush()});
  window.LMPManagerBridge={flush:flush,status:status,queueSize:function(){return readQueue().length}};
  status();
  setInterval(flush,30000);
})();